module.exports = __webpack_public_path__ + "static/media/Philip-Telkamp.61c5fca4.jpg";